module.exports = __webpack_public_path__ + "img/Prabhu_Raj_V.daa7b554.png";